import constant from '@/constant'
import { getRecentlyUsedSlides, updateRecentlyUsedSlides } from '@/utils/recentlyUsedSlide.utils'
import { getSeenNewSlideTypes, addSeenNewSlideType } from '@/utils/seenNewSlideType.utils'

// state
const _state = {
  isSlideTypeNoAudio: false,
  recentlyUsedSlideNames: [],
  seenNewSlideTypeNames: [],
}

// getters
const _getters = {
  getSlideTypeList: () => {
    return constant.allTypeSections
  },
  recentlyUsedSlideNames: (state) => state.recentlyUsedSlideNames,
  seenNewSlideTypeNames: (state) => state.seenNewSlideTypeNames,
}

// mutations
const mutations = {
  SET_RECENTLY_USED_SLIDE_NAMES(state, names) {
    state.recentlyUsedSlideNames = names
  },
  SET_SEEN_NEW_SLIDE_TYPE_NAMES(state, names) {
    state.seenNewSlideTypeNames = names
  },
}

// actions
const actions = {
  fetchRecentlyUsedSlides({ commit }, userId) {
    const names = getRecentlyUsedSlides(userId)
    commit('SET_RECENTLY_USED_SLIDE_NAMES', names)
  },
  updateRecentlyUsedSlides({ commit }, { userId, slideName }) {
    const names = updateRecentlyUsedSlides(userId, slideName)
    commit('SET_RECENTLY_USED_SLIDE_NAMES', names)
  },
  fetchSeenNewSlideTypes({ commit }, userId) {
    const names = getSeenNewSlideTypes(userId)
    commit('SET_SEEN_NEW_SLIDE_TYPE_NAMES', names)
  },
  markSlideTypeAsSeen({ commit }, { userId, slideName }) {
    const names = addSeenNewSlideType(userId, slideName)
    commit('SET_SEEN_NEW_SLIDE_TYPE_NAMES', names)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
